import {
  IRequestInsightsNotifications,
  IRequestInsightsNotificationsError,
  IRequestInsightsNotificationsSuccess,
  ISetInsightFeedback,
  ISetInsightsNotificationsOpen,
  REQUEST_INSIGHTS_NOTIFICATIONS,
  REQUEST_INSIGHTS_NOTIFICATIONS_ERROR,
  REQUEST_INSIGHTS_NOTIFICATIONS_SUCCESS,
  SET_INSIGHT_FEEDBACK,
  SET_INSIGHTS_NOTIFICATIONS_OPEN,
  SET_INSIGHTS_NOTIFICATIONS_CLOSE,
  ISetInsightsNotificationsClose,
  IAPIInsightsNotifications,
  IDeleteStaleKegNotification,
  DELETE_STALE_KEG_NOTIFICATION,
  IInsightsNotifications
} from "./types";

export const requestInsightsNotifications = (): IRequestInsightsNotifications => ({
  type: REQUEST_INSIGHTS_NOTIFICATIONS
});

export const requestInsightsNotificationsError = (): IRequestInsightsNotificationsError => ({
  type: REQUEST_INSIGHTS_NOTIFICATIONS_ERROR
});

export const requestInsightsNotificationsSuccess = (
  data: IAPIInsightsNotifications
): IRequestInsightsNotificationsSuccess => ({
  type: REQUEST_INSIGHTS_NOTIFICATIONS_SUCCESS,
  payload: data
});

export const setInsightsNotificationsOpen = (): ISetInsightsNotificationsOpen => ({
  type: SET_INSIGHTS_NOTIFICATIONS_OPEN
});

export const setInsightsNotificationsClose = (
  outletId?: string,
  insights?: IInsightsNotifications
): ISetInsightsNotificationsClose => ({
  type: SET_INSIGHTS_NOTIFICATIONS_CLOSE,
  payload: { outletId, insights }
});

export const setInsightFeedback = (
  locationId: string,
  insightId: string,
  feedback: boolean
): ISetInsightFeedback => ({
  type: SET_INSIGHT_FEEDBACK,
  payload: { locationId, insightId, feedback }
});

export const deleteStaleKegNotification = (
  locationId: string,
  pressureChamberId: string
): IDeleteStaleKegNotification => ({
  type: DELETE_STALE_KEG_NOTIFICATION,
  payload: {
    locationId,
    pressureChamberId
  }
});
